import Service from '@ember/service';
import { start as utils_start } from '../utils/aditools-site.ts';
import type { Logger, FastBoot } from '../utils/aditools-site';
export type { Logger };

// Site Configuration Service - Delivers server-side site-based configuration data to the client
export default class AditoolsSite extends Service {
  start(
    url: string,
    rootUrl: string,
    defaultLocale: string,
    supportedlocales: string[],
    logger: Logger,
    fastboot?: FastBoot,
  ): Promise<Record<string, string>> {
    return utils_start(this, url, rootUrl, defaultLocale, supportedlocales, logger, fastboot);
  }
  declare AdiLocale: string;
  declare CdpLocale: string;
  declare FullLocale: string;
  declare IsoLocale: string;
  [name: string]: unknown;
}
